import Enums from 'utils/EnumsManager';

const { REDUX_ACTION_TYPE_PREFIX } = Enums;
const { OBJECTDETAILS } = REDUX_ACTION_TYPE_PREFIX;

const SET_TOOLS = `${OBJECTDETAILS}_SET_TOOLS`;
const RESET_TOOLS = `${OBJECTDETAILS}_RESET_TOOLS`;
const DELETE_SUCCESS = `${OBJECTDETAILS}_DELETE_SUCCESS`;
const RESET = `${OBJECTDETAILS}_RESET`;

export {
  SET_TOOLS,
  RESET_TOOLS,
  DELETE_SUCCESS,
  RESET,
};



// WEBPACK FOOTER //
// ./src/components/page/DetailsToolbar/flow/actionTypes.js